import React from 'react';
import { theme } from '../../../../tailwind.config';
import { IIconProps } from 'ui/CircleIconButton';

export const CarIcon: React.FC<IIconProps> = React.memo(
  ({ className = '', icon = 'brown-100' }) => (
    <svg viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path 
    d="M16.4498 5.40786L16.0283 4.38339L15.2809 2.56667C14.6392 1.00734 13.1089 0 11.3813 0H6.61875C4.8915 0 3.36075 1.00734 2.71913 2.56667L1.97175 4.38339L1.55025 5.40786C0.64575 5.74219 0 6.58656 0 7.58333V9.33333C0 9.92104 0.231 10.4515 0.6 10.862V12.8333C0.6 13.4776 1.13737 14 1.8 14H3C3.66263 14 4.2 13.4776 4.2 12.8333V11.6667H13.8V12.8333C13.8 13.4776 14.3374 14 15 14H16.2C16.8626 14 17.4 13.4776 17.4 12.8333V10.862C17.769 10.4519 18 9.92141 18 9.33333V7.58333C18 6.58656 17.3542 5.74219 16.4498 5.40786ZM4.94737 3.43328C5.22075 2.76901 5.88263 2.33333 6.61875 2.33333H11.3813C12.1174 2.33333 12.7793 2.76901 13.0526 3.43328L13.8 5.25H4.2L4.94737 3.43328ZM3 9.32604C2.28 9.32604 1.8 8.86083 1.8 8.16302C1.8 7.46521 2.28 7 3 7C3.72 7 4.8 8.04672 4.8 8.74453C4.8 9.44234 3.72 9.32604 3 9.32604ZM15 9.32604C14.28 9.32604 13.2 9.44234 13.2 8.74453C13.2 8.04672 14.28 7 15 7C15.72 7 16.2 7.46521 16.2 8.16302C16.2 8.86083 15.72 9.32604 15 9.32604Z" 
    fill={theme.colors[icon]}/>
</svg>

  )
);

export default CarIcon;
